<template>
	<vs-tabs alignment="fixed">
		<vs-tab label="Verzendadres">
			<div class="sm:text-sm md:text-md lg:text-lg xl:text-lg">
				<Address :address="order.shipping" :order="order" />
			</div>
		</vs-tab>
		<vs-tab label="Factuuradres">
			<div class="sm:text-sm md:text-md lg:text-lg xl:text-lg">
				<Address :address="order.billing" :order="order" />
			</div>
		</vs-tab>
	</vs-tabs>
</template>

<script>
import Address from './address';

export default {
	components: {Address},
	props: {
		order: {
			type: Object,
			required: true,
		}
	}
}
</script>
